<template>
  <div class="floatBox" @click.stop="closeLoginBox">
      <div class="loginBox" @click.stop="showLoginBox">
        <span @click.stop="closeLoginBox" style="cursor:pointer;position:absolute;right:10px;top:10px;">
          <img src="@/assets/images/icon42.png" alt="" class="icon" style="width:14px;">
        </span>
        <h3>欢迎登录</h3>
        <div>
          <input type="text" placeholder="请输入用户名" class="username" v-model="loginForm.username">
        </div>
        <div class="passwordBox">
          <input :type="passwordType" placeholder="请输入密码" class="password" v-model="loginForm.password" @keyup.13="sureLogin">
          <img src="@/assets/images/img04.png" alt="" class="showPassword" @click="changePassType">
        </div>
        <div class="forgetPassword clearfix">
          <el-checkbox v-model="checked"></el-checkbox>
          <span style="margin-left:5px;">记住登录密码</span>
          <span class="forgetBtn">忘记密码?</span>
        </div>
        <button class="sureLogin" @click="sureLogin">登录</button>
      </div>
    </div>
</template>

<script>
import {Loading} from 'element-ui';
import request from '@/utils/request'
export default {
  name: 'loginBox',
  data(){
    return {
      showORhide:true,
      passwordType:'password',
      loginForm: {
        username: '',
        password: ''
      },
      checked:false
    }
  },
  props:{
    mapLoginOrindLogin:Number
  },
  created(){
    
  },
  methods:{
    //确认登录
    sureLogin(){
      request({url:'/usercenter/login',method:'post',data:this.loginForm})
      .then(res => {
          if(res.data.code == 200){
            this.showORhide = false;
            this.$message({
              message: res.data.msg,
              type: 'success'
            })
            localStorage.setItem('portalToken',res.data.data.token);
            localStorage.setItem('portalUserId',JSON.stringify(res.data.data.user.id));
            localStorage.setItem('portalUserName',JSON.stringify(res.data.data.user.username));
            if(this.mapLoginOrindLogin == 1){
              this.$router.push({path:'/personal'})
            }else{
              window.location.reload();
            }
          }else{
            this.$message({
              message: res.data.msg,
              type: 'warning'
            });
          }
      })
      .catch(err => {
         console.log(err);
      })
    },
    //隐藏密码
    changePassType(){
      if (this.passwordType === 'password') {
        this.passwordType = 'text'
      } else {
        this.passwordType = 'password'
      }
    },
    //关闭登录弹框
    closeLoginBox(){
      this.$emit('closeLoginBoxX',false);
      this.loginForm.username = '';
      this.loginForm.password = '';
      // this.showORhide = false;
    },
    //打开登录弹框
    showLoginBox(){
      this.showORhide = true;
    }
  }
}
</script>

<style scoped>
.floatBox{z-index:9999;position:fixed;top:0;left:0;width:100%;height:100%;background:rgba(0,0,0,.4);transition:all 2s;}
.loginBox{position:relative;width:350px;padding:2%;margin:0 auto;margin-top:10%;box-sizing:border-box;background:#fff;border-radius:10px;box-shadow:0 0 10px #999;}
.loginBox h3{padding-bottom:20px;font-size:20px;color:#526281}
.username,.password{width:100%;height:40px;margin:10px 0; border:0;border-bottom:1px solid #dfe2eb;text-indent:40px;}
.username{background:url('../../assets/images/img02.png') no-repeat 0 8px;background-size:8%;}
.password{background:url('../../assets/images/img03.png') no-repeat 0 8px;background-size:8%;}
.passwordBox{position:relative;}
.showPassword{cursor:pointer;position:absolute;right:0;top:25px;width:20px;}
.forgetPassword input{vertical-align:middle}
.forgetPassword{font-size:12px;text-align:left;color:#ccc;}
.forgetBtn{float:right;cursor:pointer;}
.sureLogin{display:block;width:100%;height:40px;margin-top:30px;border:0;border-radius:20px;color:#fff;background:linear-gradient(to right,#52bdff,#0084ff);}
</style>
